function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M-.25 0v100.2H100V0zm74 77.17a15 15 0 01-6 1.09 12.2 12.2 0 01-7.34-2q-2.69-2-3.49-6.7l-1.44-8A30.83 30.83 0 0053 52.9a5.16 5.16 0 00-5-2.76h-5.18v18.44a15.52 15.52 0 00.44 4.42 2.76 2.76 0 001.64 1.84 13.41 13.41 0 003.93.65v1.6q-4.34-.24-12.11-.24-8.58 0-12.67.24v-1.6a13.68 13.68 0 003.89-.65A2.75 2.75 0 0029.62 73a15.52 15.52 0 00.44-4.41V28.8a15.52 15.52 0 00-.44-4.41 2.75 2.75 0 00-1.68-1.84 13.75 13.75 0 00-3.89-.64V20.3q4.1.24 12.19.24l8.9-.08c1.07-.05 2.3-.08 3.69-.08q11.07 0 16.64 3.61a11.6 11.6 0 015.58 10.35 14 14 0 01-4.17 10q-4.17 4.34-13.8 5.45 7.22.64 10.75 3.13a11.58 11.58 0 014.57 7.48l1.84 8.26a13.69 13.69 0 001.49 4.49 2.67 2.67 0 002.37 1.29 4 4 0 001.64-.44 7 7 0 001.56-1.36l1.12 1a13.16 13.16 0 01-4.65 3.48z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M55.29 45q2.45-3.48 2.44-9.82 0-6.59-2.32-9.95t-7.62-3.36a6.72 6.72 0 00-3.17.56 3.06 3.06 0 00-1.4 2 17.26 17.26 0 00-.4 4.33v19.77h3.45q6.57 0 9.02-3.53z"
});

function SvgRemodeler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2);
}

export default SvgRemodeler;